import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useRef,
  ReactNode,
} from "react";
import { SchedulerConfig } from "../../Interface/scheduler/form";
interface FormConfigContextType {
  formConfig: SchedulerConfig;
  setFormConfig: React.Dispatch<React.SetStateAction<SchedulerConfig>>;
  initialFormConfig: SchedulerConfig | null;
}

export const FormConfigContext = createContext<
  FormConfigContextType | undefined
>(undefined);

export const FormConfigProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [formConfig, setFormConfig] = useState<SchedulerConfig | null>(null);
  const initialFormConfigRef = useRef<SchedulerConfig | null>(null);

  // Initialize the initialFormConfigRef only once
  if (initialFormConfigRef.current === null && formConfig !== null) {
    initialFormConfigRef.current = formConfig;
  }
  const contextValue = useMemo(
    () => ({
      formConfig,
      setFormConfig,
      initialFormConfig: initialFormConfigRef.current,
    }),
    [formConfig, setFormConfig]
  );
  return (
    <FormConfigContext.Provider value={contextValue}>
      {children}
    </FormConfigContext.Provider>
  );
};

export const useFormConfigContext = () => {
  const context = useContext(FormConfigContext);
  if (!context) {
    throw new Error(
      "useFormConfigContext must be used within a FormConfigProvider"
    );
  }
  return context;
};
